import React from "react";
import { Banner, Layout } from "@shopify/polaris";
import StorePageFrame from "../userCustomDashboard/emLayout/StorePageFrame";
import InvestigationWorkspace from "../troubleshooting/InvestigationWorkspace";

const StoreEventsAndLogs = () => (
  <StorePageFrame title="Events & logs" maxWidth="1400px">
    <Banner title="Read-only investigation workspace" status="info">
      <p>These tools inspect processing, fulfillment, PayPal, event, and pull-log evidence without changing the store.</p>
    </Banner>
    <Layout><InvestigationWorkspace /></Layout>
  </StorePageFrame>
);

export default StoreEventsAndLogs;
